<template>
  <div class="not-authorized">
    <h1>{{ message }}</h1>
    <div class="not-authorized-nav">
      <idf-button @click="logout"> Retour à la page de connexion </idf-button>
      <idf-button @click="$router.go(-1)"> Retour </idf-button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { IdfButton } from '@invivodf/ui-kit'
import { useAuthentication } from '@/retail/contexts/user/application/composables/useAuthentication'

export default defineComponent({
  name: 'VNotAuthorized',
  components: { IdfButton },
  props: {
    message: {
      type: String,
      default: `401 - Vous n'êtes pas autorisé à accéder à cette page`,
    },
  },
  setup() {
    const { logout, isUserAuthenticated } = useAuthentication()
    return { logout, isUserAuthenticated }
  },
})
</script>

<style lang="scss">
.not-authorized {
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 150px 15px;
  background-position: center;
  background-size: cover;

  &-nav {
    display: flex;
    flex-direction: column;
    gap: var(--idf-spacing-2);
    margin: auto;
  }
}
</style>
